var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m411 8.783v91.217h91.211z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m396 130c-8.284 0-15-6.716-15-15v-115h-215c-24.813 0-45 20.187-45 45v167.689c4.942-.448 9.943-.689 15-.689 51.128 0 96.897 23.376 127.186 60h162.814c8.284 0 15 6.716 15 15s-6.716 15-15 15h-143.052c9.376 18.296 15.422 38.565 17.363 60h125.689c8.284 0 15 6.716 15 15s-6.716 15-15 15h-125.689c-4.486 49.539-30.954 92.826-69.553 120h235.242c24.813 0 45-20.187 45-45v-337zm30 82h-220c-8.284 0-15-6.716-15-15s6.716-15 15-15h220c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m136 242c-74.439 0-135 60.561-135 135s60.561 135 135 135 135-60.561 135-135-60.561-135-135-135zm-8.333 120h16.667c17.46 0 31.666 14.206 31.666 31.667v16.666c0 15.174-10.73 27.884-25 30.955v5.712c0 8.284-6.716 15-15 15s-15-6.716-15-15v-5.712c-14.27-3.071-25-15.781-25-30.955 0-8.284 6.716-15 15-15s15 6.716 15 15c0 .919.748 1.667 1.667 1.667h16.667c.919 0 1.667-.748 1.667-1.667v-16.666c0-.919-.748-1.667-1.667-1.667h-16.667c-17.461 0-31.667-14.206-31.667-31.667v-16.666c0-15.174 10.73-27.884 25-30.955v-5.712c0-8.284 6.716-15 15-15s15 6.716 15 15v5.712c14.27 3.071 25 15.781 25 30.955 0 8.284-6.716 15-15 15s-15-6.716-15-15c0-.919-.748-1.667-1.667-1.667h-16.667c-.919 0-1.667.748-1.667 1.667v16.666c.001.919.749 1.667 1.668 1.667z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.5d51c264c24e81b2972ce33527fe8ede.svg";
export { ForwardRef as ReactComponent };